
export default {
  state:{
    filterAdmisiones   : null,
    filterProcesos     : null,
    filterImagenes     : null,
    filterLaboratorios : null,
    filterAtenciones   : {
      observaciones: null
    }
  },

  mutations:{

    setFilterAdmisiones(state, newData){
      state.filterAdmisiones = newData;
    },

    setFilterImagenes(state, newData){
      state.filterImagenes = newData;
    },

    setFilterLaboratorios(state, newData){
      state.filterLaboratorios = newData;
    },

    setFilterProcesos(state, newData){
      state.filterProcesos = newData;
    },

    setFilterAtenciones(state, newData){
      state.filterAtenciones = newData;
    },

    setFilterAtencionesObservaciones(state, newData){
      state.filterAtenciones.observaciones = newData;
    },

  }


}


